"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _integerPropType = _interopRequireDefault(require("@mui/utils/integerPropType"));
var _chainPropTypes = _interopRequireDefault(require("@mui/utils/chainPropTypes"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _colorManipulator = require("@mui/system/colorManipulator");
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _getOverlayAlpha = _interopRequireDefault(require("../styles/getOverlayAlpha"));
var _paperClasses = require("./paperClasses");
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var square = ownerState.square, elevation = ownerState.elevation, variant = ownerState.variant, classes = ownerState.classes;
    var slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && "elevation".concat(elevation)
        ]
    };
    return (0, _composeClasses.default)(slots, _paperClasses.getPaperUtilityClass, classes);
};
var PaperRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles["elevation".concat(ownerState.elevation)]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: function(param) {
                    var ownerState = param.ownerState;
                    return !ownerState.square;
                },
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: "1px solid ".concat((theme.vars || theme).palette.divider)
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    };
}));
var Paper = /*#__PURE__*/ React.forwardRef(function Paper(inProps, ref) {
    var _theme_vars_overlays;
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    var theme = (0, _zeroStyled.useTheme)();
    var className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_elevation = props.elevation, elevation = _props_elevation === void 0 ? 1 : _props_elevation, _props_square = props.square, square = _props_square === void 0 ? false : _props_square, _props_variant = props.variant, variant = _props_variant === void 0 ? 'elevation' : _props_variant, other = _object_without_properties(props, [
        "className",
        "component",
        "elevation",
        "square",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    if (process.env.NODE_ENV !== 'production') {
        if (theme.shadows[elevation] === undefined) {
            console.error([
                "MUI: The elevation provided <Paper elevation={".concat(elevation, "}> is not available in the theme."),
                "Please make sure that `theme.shadows[".concat(elevation, "]` is defined.")
            ].join('\n'));
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, _object_spread_props(_object_spread({
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref
    }, other), {
        style: _object_spread({}, variant === 'elevation' && _object_spread({
            '--Paper-shadow': (theme.vars || theme).shadows[elevation]
        }, theme.vars && {
            '--Paper-overlay': (_theme_vars_overlays = theme.vars.overlays) === null || _theme_vars_overlays === void 0 ? void 0 : _theme_vars_overlays[elevation]
        }, !theme.vars && theme.palette.mode === 'dark' && {
            '--Paper-overlay': "linear-gradient(".concat((0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlpha.default)(elevation)), ", ").concat((0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlpha.default)(elevation)), ")")
        }), other.style)
    }));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: _propTypes.default.elementType,
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */ elevation: (0, _chainPropTypes.default)(_integerPropType.default, function(props) {
        var elevation = props.elevation, variant = props.variant;
        if (elevation > 0 && variant === 'outlined') {
            return new Error("MUI: Combining `elevation={".concat(elevation, '}` with `variant="').concat(variant, '"` has no effect. Either use `elevation={0}` or use a different `variant`.'));
        }
        return null;
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: _propTypes.default.bool,
    /**
   * @ignore
   */ style: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'elevation'
   */ variant: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'elevation',
            'outlined'
        ]),
        _propTypes.default.string
    ])
} : void 0;
var _default = exports.default = Paper;
